var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policy"},[_vm._v("\n  PrivacyPolicy\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }